export const PAGE_LOGIN = '/login';
export const LOGOUT = '/logout';
export const RESET = '/reset';
export const PAGE_OVERVIEW = '/overview';
export const PAGE_METRICS = '/metrics';
export const PAGE_ALARMS = '/alarms';
// export const PAGE_REPORT = '/report';
export const PAGE_SETTINGS = '/settings';
export const PAGE_SETTINGS_TAB = '/settings/:tab';
export const SET_PROFILE = '/set_profile';
export const ORGANISATION_SELECTOR = 'organisation';



// WEBPACK FOOTER //
// ./src/utils/types.js